// Device-node helpers (spec §10/§11). A device is a first-class tree node (a folder row with
// node_kind="device") that carries this encrypted metadata and contains child access items.

export interface DeviceMeta {
  category?: string;
  address?: string;
  vendor?: string;
  notes?: string;
}

export const DEVICE_CATEGORIES = ["Network", "Server", "Storage", "BMC/iDRAC", "Firewall", "UPS", "Camera", "Other"];

const DEVICE_ICONS: Record<string, string> = {
  Network: "🌐",
  Server: "🖥️",
  Storage: "🗄️",
  "BMC/iDRAC": "🧰",
  Firewall: "🧱",
  UPS: "🔋",
  Camera: "📷",
  Other: "📟",
};

export function deviceIcon(category?: string): string {
  return DEVICE_ICONS[category ?? "Other"] ?? "📟";
}
